import add from "./add";
import add_row from "./add_row";
import add_day from "./add_day";
import add_tag from "./add_tag";
import badge from "./badge";
import bell from "./bell";
import breadcrumb from "./breadcrumb";
import breadcrumb2 from "./breadcrumb2";
import check from "./check";
import caret from "./caret";
import checkbox from "./checkbox";
import check_solid from "./check_solid";
import chevron_down from "./chevron_down";
import date from "./date";
import dflt from "./default.js";
import download from "./download.js";
import download_pub from "./download_pub";
import editor from "./editor";
import exclamation_circle from "./exclamation_circle";
import close from "./close";
import open_sidebar from "./open_sidebar";
import close_dialog from "./close_dialog";
import close_notification from "./close_notification";
import delete_row from "./delete_row";
import hammer from "./hammer";
import home from "./home.js";
import image_upload from "./image_upload";
import info from "./info";
import m_close from "./m_close";
import profiledown from "./profiledown";
import row_uk from "./row_uk";
import row from "./row";
import remove from "./remove";
import report from "./report.js";
import request from "./request";
import stats from "./stats.js";
import success from "./success";
import video_flight from "./video_flight.js";
import campaigns from "./campaigns.js";
import dlt from "./delete.js";
import edit_cd from "./edit_cd";
import edit from "./edit.js";
import outline from "./outline";
import outline_x from "./outline_x";
import preview from "./preview.js";
import settings from "./settings.js";
import upload from "./upload.js";
import uploaded from "./uploaded";
import vastEditor from "./vastEditor.js";
import view from "./view.js";
import dashboard from "./dashboard.js";
import demand_partners from "./demand_partners.js";
import iab from "./iab.js";
import publishers from "./publishers.js";
import settings_white from "./settings_white.js";
import status from "./status";
import toggle_down from "./toggle_down";
import toggle_up from "./toggle_up";
import video from "./video.js";
import iab_blacklist from "./iab-blacklist";
import adomain_blacklist from "./adomain_blacklist";
import bid_template from "./bid_template";
import sidebar_toggler from "./sidebar_toggler";
import arrow_asc from "./arrow_asc";
import arrow_up_down from './arrow_up_down';
import arrow_desc from './arrow_desc';
import toggle_on from './toggle_on';
import toggle_off from './toggle_off';
import copy from "./copy";

export default {
  add,
  add_day,
  add_row,
  add_tag,
  badge,
  bell,
  breadcrumb,
  breadcrumb2,
  check,
  checkbox,
  check_solid,
  chevron_down,
  close,
  close_dialog,
  close_notification,
  copy,
  caret,
  date,
  delete_row,
  dlt,
  download,
  download_pub,
  editor,
  exclamation_circle,
  profiledown,
  hammer,
  home,
  info,
  m_close,
  open_sidebar,
  remove,
  row_uk,
  row,
  report,
  request,
  stats,
  video_flight,
  campaigns,
  dflt,
  edit,
  edit_cd,
  outline,
  outline_x,
  preview,
  settings,
  status,
  success,
  toggle_down,
  toggle_up,
  toggle_on,
  toggle_off,
  upload,
  uploaded,
  vastEditor,
  view,
  dashboard,
  demand_partners,
  iab,
  image_upload,
  publishers,
  settings_white,
  video,
  sbtoggler: sidebar_toggler,
  blacklist: adomain_blacklist,
  arrow_asc,
  arrow_up_down,
  arrow_desc,
  bid_template,

  ["iab-blacklist"]: iab_blacklist,
};
